import { wallToUtc, zoneParts } from "./zone.ts";

const TZ = "America/Toronto";
const dateFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: TZ,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});
/** Local calendar date (YYYY-MM-DD) of an instant in America/Toronto. */
export const torontoDate = (d: Date): string => dateFmt.format(d);

/** UTC instant of 00:00 America/Toronto on `date` (YYYY-MM-DD); DST handled by the shared zone resolver. */
export const torontoMidnight = (date: string): Date => {
  const [y, m, d] = date.split("-").map(Number);
  return wallToUtc(Date.UTC(y, m - 1, d), TZ);
};

export const addDays = (date: string, n: number): string => {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
};

/** ISO weekday (1 = Monday) and hour (0–23) in America/Toronto; SQL: extract(isodow|hour from ts at time zone …). */
export const torontoDowHour = (d: Date): { dow: number; hour: number } => {
  const p = zoneParts(d, TZ);
  return { dow: p.weekday, hour: p.hour };
};
